module.exports = __webpack_public_path__ + "static/media/photo-icon4.cc3b90cf.svg";